import React, { useEffect, useRef, useState } from 'react';
import {
    _getSite,
    _hideSpinner,
    _showError
} from '../../../store/system/service';
import {
    _checkQrCodePaymentComplete,
    } from '../../../store/policy-payment/service';
import {
    _getPolicy,
    _storePolicy,
    _logPaymentLifecycle
} from "../../../store/policy/service";
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

const CheckPaymentComplete = (props) => {
    const {txnRef}  = props;
    const [transRef] = useState(txnRef);
    const [success] = useState(false);
    const [successCount, setSuccessCount] = useState(0);
    const [issued, setIssued] = useState(false);
    const mountedRef = useRef(false);
    let timeoutId= null;

    const handleCheckQrCodePayment = () => {
        console.log("handleCheckQrCodePayment...."+txnRef);
        console.log("handleCheckQrCodePayment...."+transRef);
        props.policy.payment = {
            paymentReferenceNumber: transRef
        };

        props.checkQrCodePayment(props.policy).then(resp => {
            if (resp.success) {
                props.storePolicy(props.policy);
                console.log("trans: " + txnRef + " Policy Issued...");
                if(successCount ===0){
                   showPaymentFinish();
                }
            } else if (resp.error) {
                props.showError([resp.message]);
                props.policy.errorMessage=resp.message;
                props.storePolicy(props.policy);
                props.callLogPaymentLifecycle(props.policy).then(() => {
                    console.log('payment lifecycle added ');
                }, (err) => {
                    console.log('_logPaymentLifecycle failed: ' + err);
                })
            } else {
                console.log("PayNow QR Code Payment: policy is still not issued");
                if(mountedRef.current){
                    timeoutId = setTimeout(() => {
                        console.log('setTimeout!!!!');
                        handleCheckQrCodePayment();
                    }, 1000); // 1 second
                }
            }
        }, (error) => {
            if (error?.data?.errorMessage) {
                props.showError([error.data.errorMessage]);
            } else {
                props.showError([error.response?.data]);
            }
        });
    }

    const showPaymentFinish = () => {
        console.log('showPaymentFinish---------to issue= '+issued);
        if(!issued){
            setSuccessCount(successCount + 1);
            setIssued(true);
            console.log("showPaymentFinish Issue Receipt success: ");
            props.history.push((props.site ? '/' + props.site : '') + '/finish');

        }
    };

    useEffect(() => {
        mountedRef.current = true;
        timeoutId=setTimeout(() => {
              console.log('setTimeout!!!!');
              handleCheckQrCodePayment();
          }, 1000); // 1 second
          if(timeoutId){
            return () => {mountedRef.current=false;
            clearTimeout(timeoutId);}
          }
    }, []);


    return <>{
        success
    }</>
}

const mapStateToProps = (state) => {
    return {
        policy: _getPolicy(state),
        site: _getSite(state)
    }
};

const mapDispatchToProps = {
    storePolicy: _storePolicy,
    checkQrCodePayment: _checkQrCodePaymentComplete,
    callLogPaymentLifecycle: _logPaymentLifecycle,
    showError: _showError,
    hideSpinner: _hideSpinner,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CheckPaymentComplete));
